
angular.module('dyb.util.input', ['dyb.util.constants']);
